import { Component, Input } from '@angular/core';
import { FiAppearanceWidgetSettingsComponent, FiAppearanceWidgetSettingsParent } from './widget-settings.component';

@Component({
    selector: 'fi-appearance-widget-settings-wrap',
    template: '<ng-container *ngComponentOutlet="getComponentType()"></ng-container>',
    providers: [
        {
            provide: FiAppearanceWidgetSettingsParent,
            deps: [FiAppearanceStartPageEditControlContentWrap],
            useFactory: (instance) => instance,
        },
    ],
    standalone: false,
})
export class FiAppearanceStartPageEditControlContentWrap {
    @Input() selectedControl;
    @Input() isStartPage: boolean;

    public getComponentType() {
        return FiAppearanceWidgetSettingsComponent;
    }
}
